import { Suspense, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Dialog } from "@mui/material";
import PageLoader from "../loader/LoaderText";
import ProjectMasterPage from "./Projects";
import DocumentMasterPage from "./Documents";
import EventRegister from "./Events";
import TenderDialogPage from "./Tender";
import UsersMasterPage from "./Users";
import AdminTableViewDialog from "./AdminTable";
import WorkflowMasterDialogComponent from "./Workflow";
import UserRegisterPage from "./UserRegister";
import SewaMasterPage from "./sewa-master";
import { TEMPLE, TEMPLE_RADIUS, TEMPLE_SHADOW_HOVER } from "../common/templeStyles";

const CommonDialogComponent = () => {
    const [mounted, setMounted] = useState(false);
    const { isOpen, isFullScreen, size } = useSelector((state: RootState) => state.dialog);

    useEffect(() => {
        if (isOpen && !mounted) {
            setMounted(true);
        }
    }, [isOpen, mounted]);

    return (
        <Dialog
            open={isOpen}
            fullScreen={isFullScreen}
            fullWidth
            maxWidth={(size as 'xs' | 'sm' | 'md' | 'lg' | 'xl') ?? 'md'}
            sx={{
                backdropFilter: 'blur(3px) sepia(8%)',
                '& .MuiBackdrop-root': { backgroundColor: 'rgba(58, 42, 26, 0.45)' },
            }}
            PaperProps={{
                sx: {
                    borderRadius: isFullScreen ? 0 : `${TEMPLE_RADIUS}px`,
                    border: `1px solid ${TEMPLE.line}`,
                    boxShadow: TEMPLE_SHADOW_HOVER,
                    backgroundColor: TEMPLE.cream,
                    backgroundImage: `linear-gradient(180deg, #fff 0%, ${TEMPLE.cream} 100%)`,
                },
            }}
        >
            <Suspense fallback={<PageLoader />}>
                <ProjectMasterPage />
                <DocumentMasterPage />
                <EventRegister />
                <UserRegisterPage />
                <TenderDialogPage />
                <UsersMasterPage />
                <AdminTableViewDialog />
                <WorkflowMasterDialogComponent />
                <SewaMasterPage />

            </Suspense>
        </Dialog>
    )
}
export default CommonDialogComponent